import axios from "axios";
import { tokenService } from "./tokenService";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL_ANN_WEB_DEV,
});

api.interceptors.request.use((config) => {
  const token = tokenService.getToken();
  if (token) config.headers.Authorization = `${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const userUuid = localStorage.getItem("user_uuid");
        const tenantUuid = localStorage.getItem("workspace_uuid");
        
        if (!userUuid) throw new Error("user_uuid NOT FOUND in localStorage");
        if (!tenantUuid) throw new Error("workspace_uuid NOT FOUND in localStorage");

        const newToken = await tokenService.refreshToken(userUuid, tenantUuid);
        api.defaults.headers.common["Authorization"] = newToken;
        originalRequest.headers.Authorization = newToken;

        return api(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
